var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _path, _rect2, _rect3, _rect4, _circle6, _circle7, _circle8, _g, _g2, _g3, _g4, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f8fafc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e2e8f0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "headGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fbbf24",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f59e0b",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a8a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bgGradient)",
    rx: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 160,
    r: 60,
    fill: "url(#headGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 150,
    r: 8,
    fill: "#1f2937"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 150,
    r: 8,
    fill: "#1f2937"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 187,
    cy: 148,
    r: 3,
    fill: "#1e3a8a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 148,
    r: 3,
    fill: "#1e3a8a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 180 170 Q 200 185 220 170",
    stroke: "#1f2937",
    strokeWidth: 3,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 220,
    width: 80,
    height: 100,
    rx: 20,
    fill: "url(#accentGradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 240,
    width: 60,
    height: 40,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 245,
    width: 50,
    height: 30,
    rx: 3,
    fill: "#1e3a8a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 260,
    r: 2,
    fill: "#f59e0b"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 260,
    r: 2,
    fill: "#f59e0b"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 260,
    r: 2,
    fill: "#f59e0b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -20 -10 L 20 -10 L 15 -5 L -15 -5 Z",
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -5,
    r: 3,
    fill: "#f59e0b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#1e3a8a",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 12,
    fontFamily: "monospace"
  }, "R"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#f59e0b",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 12,
    fontFamily: "monospace"
  }, "E"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 3,
    fill: "#10b981",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 12,
    fontFamily: "monospace"
  }, "S"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 130 L 160 160",
    stroke: "#1e3a8a",
    strokeWidth: 2,
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 160 L 260 160",
    stroke: "#f59e0b",
    strokeWidth: 2,
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 340 290 L 260 300",
    stroke: "#10b981",
    strokeWidth: 2,
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.080632f90da81a2970731e9df32aa138.svg";
export { ForwardRef as ReactComponent };